import { bt, vehClass } from '@/i18n/bookingI18n';
import { TRANSFER_VEHICLES, CITY_LOCATIONS, cityBaseRate, AIRPORT_ARRIVAL_FEE, fareVAT, money } from '@/data/transportPricing';
import { validateSchedule, validateContact } from '@/components/booking/validateCommon';

export function transferPriceFor({ mode, zone, fi, ti, v }) {
  if (mode === 'airport') return zone ? zone.prices[TRANSFER_VEHICLES.indexOf(v)] : null;
  if (fi == null || ti == null || fi === ti) return null;
  const base = cityBaseRate(fi, ti);
  return base == null ? null : base + v.supp;
}

function airportEstimate({ airport, zone, vehicle, returnTrip, vName, retWord, retSuffix, lang }) {
  if (!zone) return null;
  const oneWay = zone.prices[TRANSFER_VEHICLES.indexOf(vehicle)];
  const net = returnTrip ? oneWay * 2 : oneWay;
  const { vat, total } = fareVAT(net + AIRPORT_ARRIVAL_FEE);
  return {
    summary: `${airport.name} → ${zone.name}${retWord} · ${vName}`,
    pickup: airport.name,
    dropoff: `${zone.name} — ${zone.areas}`.slice(0, 200),
    lines: [
      { label: `${vName}${retSuffix}`, value: money(net) },
      { label: bt(lang, 'airportParking'), value: money(AIRPORT_ARRIVAL_FEE) },
      { label: bt(lang, 'vat5'), value: money(vat) },
    ],
    total,
  };
}

function cityEstimate({ vehicle, fi, ti, returnTrip, vName, retWord, retSuffix, lang }) {
  if (fi == null || ti == null || fi === ti) return null;
  const base = cityBaseRate(fi, ti);
  if (base == null) return null;
  const net = (base + vehicle.supp) * (returnTrip ? 2 : 1);
  const { vat, total } = fareVAT(net);
  return {
    summary: `${CITY_LOCATIONS[fi]} → ${CITY_LOCATIONS[ti]}${retWord} · ${vName}`,
    pickup: CITY_LOCATIONS[fi],
    dropoff: CITY_LOCATIONS[ti],
    lines: [
      { label: `${vName}${retSuffix}`, value: money(net) },
      { label: bt(lang, 'vat5'), value: money(vat) },
    ],
    total,
  };
}

export function computeTransferEstimate({ mode, airport, zone, vehicle, fi, ti, returnTrip, lang }) {
  if (!vehicle) return null;
  const shared = {
    vehicle,
    returnTrip,
    lang,
    vName: vehClass(lang, vehicle.name),
    retWord: returnTrip ? ` (${bt(lang, 'returnWord')})` : '',
    retSuffix: returnTrip ? bt(lang, 'returnSuffix') : '',
  };
  if (mode === 'airport') return airportEstimate({ airport, zone, ...shared });
  return cityEstimate({ fi, ti, ...shared });
}

function validateRoute({ mode, zoneId, fi, ti, lang }) {
  const e = {};
  if (mode === 'airport') {
    if (!zoneId) e.zone = bt(lang, 'errZone');
    return e;
  }
  if (fi == null) e.from = bt(lang, 'errFrom');
  if (ti == null) e.to = bt(lang, 'errTo');
  else if (fi != null && fi === ti) e.to = bt(lang, 'errToDiff');
  else if (fi != null && cityBaseRate(fi, ti) == null) e.to = bt(lang, 'errRoute');
  return e;
}

export function validateTransfer({ mode, zoneId, fi, ti, vehicleId, date, time, form, lang }) {
  const e = { ...validateRoute({ mode, zoneId, fi, ti, lang }), ...validateSchedule({ date, time, lang }), ...validateContact({ form, lang }) };
  if (!vehicleId) e.vehicle = bt(lang, 'errVehicleClass');
  return e;
}
